import permissions from './module/permissions';
import ClickOutside from 'vue-click-outside';
import draggable from './module/draggable';

const directives = {
  permissions,
  ClickOutside,
  draggable,
};

export default directives;
